import React, { useState, useEffect, Fragment } from 'react';
import firstImage from '../images/primero.png';
import secondImage from '../images/segundo.png';
import thirdImage from '../images/tercero.png';
import { Link, useNavigate } from 'react-router-dom';
import TwoButtons from '../components/twoButtons';
import SelectorJornada, { vistaPorDefecto, puntosEn, ultimoVinoEn, filasDeJornada } from '../components/selectorJornada';
import { useJornadaEnCurso, revelacionDe, claseRevelable } from '../components/revelacion';

// Liga: por el total y, si empatan, por los puntos del mes pasado y por vinos catados
const sortByTotal = (users) => {
    users.sort((a, b) => {
        if (b.total_points !== a.total_points) {
            return b.total_points - a.total_points;
        } else if (b.month !== a.month) {
            return b.month - a.month;
        } else {
            return b.wines - a.wines;
        }
    });
};
export default function Ranking() {

    const [userData, setUserData] = useState([]);
    const [vistaElegida, setVistaElegida] = useState(null); // la liga o el id de una jornada; null, la de por defecto
    const [orden, setOrden] = useState('jornada'); // en una jornada: por sus puntos o por los del ultimo vino
    const estado = useJornadaEnCurso(); // la jornada en curso y su revelacion
    const navigate = useNavigate();

    const fetchUserData = () => {
        const xhr = new XMLHttpRequest();
        const url = `${process.env.REACT_APP_API_URL}/users`;

        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    const users = JSON.parse(this.responseText);
                    sortByTotal(users);
                    setUserData(users);
                } else {
                    console.error("Error al obtener los datos de los usuarios:", this.status, this.responseText);
                }
            }
        };
        xhr.send();
    };

    // Se piden al entrar y otra vez cada vez que cambia la jornada en curso o su
    // revelacion (se cierra un vino, se desvela un puesto): asi lo que enfoca es lo ultimo
    useEffect(() => {
        fetchUserData();
    }, [estado]);

    const redirectToUserPage = (userId) => {
        navigate(`/user/${userId}`);
    };

    const [hoveredDiv, setHoveredDiv] = useState(null);
    const handleMouseEnter = (divName) => {
        setHoveredDiv(divName);
    };

    const handleMouseLeave = () => {
        setHoveredDiv(null);
    };

    // Sin elegir nada, se abre la jornada que se esta jugando (si no hay, la liga)
    const vista = vistaElegida || vistaPorDefecto(estado);
    const enLiga = vista === 'liga';

    // Mientras se desvela, tapa la jornada y, si cuenta, la liga. La tabla va
    // entonces por los puntos: ordenada por el ultimo vino, los puestos que se
    // desvelan no serian los del podio
    const revelacion = revelacionDe(estado, vista);
    const ordenActivo = revelacion ? 'jornada' : orden;

    // El podio va por los puntos de la vista (en la liga, el total), ordene como
    // se ordene la tabla, y solo con quien tiene puntos
    let porPuntos = enLiga ? [...userData] : filasDeJornada(userData, vista);
    if (enLiga) sortByTotal(porPuntos);
    const podium = porPuntos.filter((user) => puntosEn(vista, user) > 0);
    const filas = enLiga || ordenActivo === 'jornada' ? porPuntos : filasDeJornada(userData, vista, 'vino');

    // Cabecera de una columna de la jornada: pulsandola se ordena por ella
    // (la flecha dice que se puede), salvo mientras esta oculta
    const cabecera = (columna, texto) => (
        <div
            className="title"
            style={{ cursor: revelacion ? 'default' : 'pointer' }}
            onClick={() => !revelacion && setOrden(columna)}
            onMouseEnter={() => handleMouseEnter(columna)}
            onMouseLeave={handleMouseLeave}
        >
            {revelacion || ordenActivo === columna ? texto : texto + ' ▼'}
        </div>
    );

    return (
        <div className="winegangs-container">
            <div className="ranking-container">
                <h2>Hall of Fame</h2>
                <SelectorJornada vista={vista} onChange={setVistaElegida} recargar={estado && estado.en_curso} />
                <div className="row">
                    {podium.length > 1 && (
                        <div className="col-sm-4 ranking-second">
                            <img src={secondImage} alt="Segundo" className="ranking-image" />
                            <div className={claseRevelable(revelacion, 2)}>{podium[1].username} {puntosEn(vista, podium[1])} <br />{podium[1].relevant_winegang.name ? '(' + podium[1].relevant_winegang.name + ')': ''}</div>
                        </div>
                    )}
                    {podium.length > 0 && (
                        <div className="col-sm-4 ranking-first">
                            <img src={firstImage} alt="Primero" className="ranking-image" />
                            <div className={claseRevelable(revelacion, 1)}>{podium[0].username} {puntosEn(vista, podium[0])} <br />{podium[0].relevant_winegang.name ? '(' + podium[0].relevant_winegang.name + ')' : ''}</div>
                        </div>
                    )}
                    {podium.length > 2 && (
                        <div className="col-sm-4 ranking-third">
                            <img src={thirdImage} alt="Tercero" className="ranking-image" />
                            <div className={claseRevelable(revelacion, 3)}>{podium[2].username} {puntosEn(vista, podium[2])} <br />{podium[2].relevant_winegang.name ? '(' + podium[2].relevant_winegang.name + ')' : ''}</div>
                        </div>
                    )}
                </div>
                <div className="main-table ranking-table">
                    {hoveredDiv === 'liga' && <div className="hovered-info">Total de puntos de la liga</div>}
                    {hoveredDiv === 'jornada' && <div className="hovered-info">Puntos de la jornada</div>}
                    {hoveredDiv === 'vino' && <div className="hovered-info">Puntos del último vino de la jornada</div>}
                    <div className={'ranking-row title-tab ' + (enLiga ? 'una-columna' : 'dos-columnas')}>
                        <div className="title">Pos.</div>
                        <div className="title ">Nombre (Equipo)</div>
                        {enLiga ? (
                            <div className="title" onMouseEnter={() => handleMouseEnter('liga')} onMouseLeave={handleMouseLeave}>Total</div>
                        ) : (
                            <>
                                {cabecera('jornada', 'Jornada')}
                                {cabecera('vino', 'Últ. vino')}
                            </>
                        )}
                    </div>
                    <div className={'ranking-row ' + (enLiga ? 'una-columna' : 'dos-columnas')}>
                        {filas.map((user, index) => (
                            <Fragment key={user.id}>
                                <div className="pos">{index + 1}</div>
                                <button className={'item ' + claseRevelable(revelacion, index + 1)} onClick={() => redirectToUserPage(user.id)}>{user.username} ({user.relevant_winegang.name ? user.relevant_winegang.name : ''})</button>
                                {enLiga ? (
                                    <div className={'item ' + claseRevelable(revelacion, index + 1)}>{user.total_points}</div>
                                ) : (
                                    <>
                                        <div className={'item ' + claseRevelable(revelacion, index + 1)}>{puntosEn(vista, user)}</div>
                                        <div className={'item ' + claseRevelable(revelacion, index + 1)}>{ultimoVinoEn(vista, user)}</div>
                                    </>
                                )}
                            </Fragment>
                        ))}
                    </div>
                    {!enLiga && filas.length === 0 && <p className="ranking-vacia">Aún no se ha cerrado ningún vino.</p>}
                </div>
                <div className="ranking-buttons row">
                    <button className="rank-indi"><Link to="/ranking">Individual</Link></button>
                    <button className="rank-wine"><Link to="/ranking-gangs">Winegangs</Link></button>
                </div>
            </div>
            <TwoButtons />
        </div>
    );
}
